import { RESPONSIVE_BREAKPOINTS } from 'constants/Global/ResponsiveLayout.const';
import styled from 'styled-components';

const tablet = `${RESPONSIVE_BREAKPOINTS.tablet}px`;

export const Card = styled.li`
  overflow: hidden;
  list-style: none;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
`;

export const Placeholder = styled.div`
  padding: 12px;

  .ant-skeleton-title {
    margin-top: 0;
  }

  .ant-skeleton-paragraph {
    margin-top: 12px !important;
    margin-bottom: 0;
  }
`;

export const Body = styled.button`
  display: grid;
  grid-template-areas:
    'header header'
    'source source'
    'quantity total';
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: baseline;
  width: 100%;
  padding: 12px;
  font: inherit;
  font-size: 13px;
  color: #263238;
  text-align: left;
  cursor: pointer;
  background: none;
  border: 0;

  @media (min-width: ${tablet}) {
    grid-template-areas:
      'header total'
      'source quantity';
    gap: 8px 16px;
    padding: 12px 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  grid-area: header;
  gap: 8px;
  align-items: flex-start;
  justify-content: space-between;
  min-width: 0;

  .ant-tag {
    flex: none;
    margin: 0;
  }

  @media (min-width: ${tablet}) {
    align-items: center;
    justify-content: flex-start;
  }
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Title = styled.strong`
  display: -webkit-box;
  overflow: hidden;
  line-height: 1.35;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  @media (min-width: ${tablet}) {
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Code = styled.span`
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 11px;
  font-weight: 400;
  color: #8c8c8c;
`;

export const Source = styled.div`
  display: flex;
  grid-area: source;
  gap: 8px;
  align-items: center;
  min-width: 0;
  font-size: 12px;
  color: #595959;
`;

export const Parties = styled.span`
  display: -webkit-box;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  @media (min-width: ${tablet}) {
    display: block;
    flex: 0 1 auto;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Quantity = styled.span`
  grid-area: quantity;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: #595959;

  @media (min-width: ${tablet}) {
    text-align: right;
  }
`;

export const Total = styled.strong`
  grid-area: total;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  text-align: right;
`;

export const Hint = styled.p`
  margin: 0;
  font-size: 13px;
  color: #595959;
  text-align: center;
`;
